import React from 'react';
import {
    Link,
    BrowserRouter as Router,
} from "react-router-dom";

function Navbar(props) {
    return (
        <ul id="navbar">
            <li>
                <Link to="/"> Home</Link>
            </li>
            <li>
                <Link to="/about"> About</Link>
            </li>
            <li>
                <Link to="/courses"> Courses</Link>
            </li>
            <li>
                <Link to="/contact"> Contact</Link>
            </li>
        </ul>
    );
}

export default Navbar;